import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    document.addEventListener('keydown', this.handleKeydown);
  }

  disconnect() {
    document.removeEventListener('keydown', this.handleKeydown);
  }

  handleKeydown = (e) => {
    if (!document.body.classList.contains('public-layout')) return;

    const active = document.activeElement;
    const input = this.element;
    const isFocused = document.activeElement === input;

    // Escape to blur
    if (e.key === 'Escape') {
      if (isFocused) {
	input.blur();
	input.value = "";
	e.preventDefault();
      }
      return;
    }

    // Ignore modified keys (e.g., Ctrl, Alt, Meta)
    if (e.ctrlKey || e.metaKey || e.altKey) return;

    if (active.isEditable) return;
    if (['TEXTAREA', 'SELECT'].includes(active.tagName)) return;
    // Ignore focused category buttons
    if (['INPUT'].includes(active.tagName) && active.name !== "category_ids[]") return;

    const allowedKeys = /^[a-z0-9 ]$/i;
    if (!allowedKeys.test(e.key)) return;

    e.preventDefault();
    input.focus();
    input.value = isFocused ? input.value + e.key : e.key;
    input.dispatchEvent(new Event('input'));
  }

}
